import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FaBars, FaTimes, FaPhoneAlt, FaChevronDown } from "react-icons/fa";
import "./Navbar.css";
import logo from "../assets/logo.png";

// Product items
const productItems = [
  { title: "Plating and Specialty Chemicals", path: "/products/plating-and-speciality-chemicals" },
  { title: "Basic and Lab Chemicals", path: "/products/basic-and-lab-chemicals" },
  { title: "Metals", path: "/products/metals" },
  { title: "Abrasives", path: "/products/abrasives" },
  { title: "Cutting Tools", path: "/products/cutting-tools" },
  { title: "Wood & Glass Coatings", path: "/products/wood-glass-coatings" },
  { title: "Metal Coatings", path: "/products/metal-coatings" },  
];

const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false); // mobile menu
  const [dropdownOpen, setDropdownOpen] = useState(false); // products dropdown

  // Close mobile + dropdown after clicking a link
  const handleLinkClick = () => {
    setIsOpen(false);
    setDropdownOpen(false);
  };

  return (
    <nav className="navbar">
      <div className="nav-container">
        {/* Logo */}
        <div className="nav-logo">
          <img src={logo} alt="Sreenathji Enterprises" />
        </div>

        {/* Menu */}
        <ul className={`nav-menu ${isOpen ? "active" : ""}`}>
          <li>
            <NavLink to="/" end onClick={handleLinkClick}>
              Home
            </NavLink>
          </li>
          <li>
            <NavLink to="/about" onClick={handleLinkClick}>
              About
            </NavLink>
          </li>
          <li>
            <NavLink to="/partners" onClick={handleLinkClick}>
              Partners
            </NavLink>
          </li>

          {/* Products Dropdown */}
<li
  className="dropdown"
  onMouseEnter={() => window.innerWidth > 1023 && setDropdownOpen(true)}
  onMouseLeave={() => window.innerWidth > 1023 && setDropdownOpen(false)}
>
  <div className="dropdown-header">
    {/* Main Products page link */}
    <NavLink to="/products" className="dropdown-link">
      Products
    </NavLink>

    {/* Toggle button only for mobile */}
    <button
      className="dropdown-toggle"
      onClick={(e) => {
        e.preventDefault(); // Prevent navigation on toggle click
        setDropdownOpen(!dropdownOpen);
      }}
    >
      <FaChevronDown />
    </button>
  </div>

  {dropdownOpen && (
    <ul className="dropdown-menu">
      {productItems.map((item, index) => (
        <li key={index}>
          <NavLink to={item.path} onClick={handleLinkClick}>
            {item.title}
          </NavLink>
        </li>
      ))}
    </ul>
  )}
</li>


          <li>
            <NavLink to="/careers" onClick={handleLinkClick}>
              Careers
            </NavLink>
          </li>
          <li>
            <NavLink to="/events" onClick={handleLinkClick}>
              Events
            </NavLink>
          </li>
          <li className="contact-link">
            <NavLink to="/contact" onClick={handleLinkClick}>
              Contact
            </NavLink>
          </li>
        </ul>

        {/* Right Actions */}
        <div className="nav-actions">
          <a href="tel:+919972812736" className="phone">
            <FaPhoneAlt style={{ marginRight: "6px" }} />
            +91-99728 12736
          </a>
          <a href="/contact" className="btn">
            Reach Us
          </a>
        </div>

        {/* Mobile Toggle */}
        <div className="nav-toggle" onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
